import { Box, Typography } from '@mui/material'
import { useAtomValue } from 'jotai'
import * as React from 'react'

import NavigationItems from '../components/common/NavigationItems'
import { currentUserAtom } from '../domains/user/AtomUsers'

export default function SiteMap() {
  const user = useAtomValue(currentUserAtom)

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom align="center">
        Site Map
      </Typography>

      <NavigationItems
        user={user}
        sx={{
          maxWidth: 600,
          margin: '0 auto',
          px: { xs: 2, sm: 4 },
        }}
        titleSx={{
          mt: (index) => (index === 0 ? 2 : 4),
          fontSize: '0.875rem',
          textAlign: 'center',
        }}
        itemSx={{
          justifyContent: 'center',
          px: 2,
          '& .MuiListItemIcon-root': {
            minWidth: 'unset',
            marginRight: 1,
          },
          '& .MuiListItemText-root': {
            flex: '0 1 auto',
          },
        }}
        textProps={{
          primaryTypographyProps: {
            variant: 'body1',
            align: 'left',
          },
        }}
      />
    </Box>
  )
}
